// tr strings for messages/auth.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const auth: Dict = {
  "auth.continueGoogle": "Google ile devam et",
  "auth.orEmail": "veya e-posta ile",
  "auth.email": "E-posta",
  "auth.emailInput": "E-posta alanı",
  "auth.emailPlaceholder": "sen@ornek.com",
  "auth.password": "Şifre",
  "auth.passwordInput": "Şifre alanı",
  "auth.passwordPlaceholderNew": "En az 6 karakter",
  "auth.signUp": "Kaydol",
  "auth.logIn": "Giriş yap",
  "auth.signIn": "Giriş yap",
  "auth.createAccount": "Hesap oluştur",
  "auth.createYourAccount": "Hesabını oluştur",
  "auth.forgotPassword": "Şifreni mi unuttun?",
  // Turkish puts the verb last; the links follow, so it reads
  // "Şunları kabul ediyorum: Kullanım Koşulları ve Gizlilik Politikası".
  "auth.agree": "Şunları kabul ediyorum:",
  "auth.agreeJammable": "Jammable'ın şu metinlerini kabul ediyorum:",
  "auth.and": "ve",
  "auth.terms": "Kullanım Koşulları",
  "auth.privacy": "Gizlilik Politikası",
  "auth.agreeRequired":
    "Lütfen Kullanım Koşulları'nı ve Gizlilik Politikası'nı kabul et.",
  "auth.welcomeBack": "Tekrar hoş geldin!",
  "auth.welcomeNew": "Jammable'a hoş geldin!",
  "auth.registerError": "Kayıt sırasında bir hata oluştu. Lütfen tekrar dene.",
  "auth.backToLogin": "Girişe dön",

  "auth.invalidEmail": "Geçersiz e-posta",
  "auth.emailRequired": "E-posta gerekli",
  "auth.passwordMin": "Şifre en az 6 karakter olmalı",
  "auth.passwordRequired": "Şifre gerekli",

  "auth.modal.signInTitle": "Jammable'a giriş yap",
  "auth.modal.subtitle": "100.000+ sesle AI cover yap.",
  "auth.modal.signUpButton": "Kaydol düğmesi",
  "auth.modal.signInButton": "Giriş yap düğmesi",
  "auth.modal.haveAccount": "Hesabın var mı?",
  "auth.modal.newHere": "Yeni misin?",
  "auth.modal.createAnAccount": "Hesap oluştur",

  "auth.login.heading": "Tekrar hoş geldin",
  "auth.login.blurb":
    "Cover'ların, seslerin ve koleksiyonların bıraktığın yerde seni bekliyor.",
  "auth.login.noAccount": "Hesabın yok mu?",

  "auth.signup.heading": "İstediğin sese söylet",
  "auth.signup.headingHighlight": "kendi kaydını",
  "auth.signup.blurb":
    "100.000+ ses, tüm cover'ların tek bir yerde ve düetler ile videolar için bir stüdyo.",
  "auth.signup.haveAccount": "Zaten hesabın var mı?",

  "auth.forgot.title": "Şifreni sıfırla",
  "auth.forgot.blurb":
    "E-posta adresini gir, yeni şifre belirlemen için sana bir bağlantı gönderelim.",
  "auth.forgot.send": "Sıfırlama bağlantısı gönder",
  "auth.forgot.sentToast": "Şifre sıfırlama e-postası gönderildi!",
  "auth.forgot.sent": "Gönderildi. Gelen kutunu ve spam klasörünü kontrol et.",
  "auth.forgot.google": "Google ile mi kaydoldun?",
  "auth.forgot.googleAfter": "",

  "auth.reset.title": "Yeni şifre belirle",
  "auth.reset.blurb":
    "En az 6 karakter. Bir sonraki girişte bunu kullanacaksın.",
  "auth.reset.newPassword": "Yeni şifre",
  "auth.reset.submit": "Şifreyi sıfırla",
  "auth.reset.success": "Şifre başarıyla sıfırlandı!",
  "auth.reset.expired": "Bağlantının süresi mi doldu?",
  "auth.reset.sendNew": "Yenisini gönder",

  "auth.error.google.popup-closed-by-user":
    "Giriş tamamlanmadan açılır pencere kapatıldı. Lütfen tekrar dene.",
  "auth.error.google.popup-blocked":
    "Açılır pencere tarayıcı tarafından engellendi. Lütfen açılır pencerelere izin ver ve tekrar dene.",
  "auth.error.google.operation-not-supported-in-this-environment":
    "Bu giriş yöntemi mevcut ortamında desteklenmiyor.",
  "auth.error.google.network-request-failed":
    "Bir ağ hatası oluştu. Lütfen internet bağlantını kontrol edip tekrar dene.",
  "auth.error.google.cancelled-popup-request":
    "Birden fazla giriş isteği algılandı. Lütfen tekrar dene.",
  "auth.error.google.timeout":
    "Giriş işlemi çok uzun sürdü. Lütfen internet bağlantını kontrol edip tekrar dene.",
  "auth.error.google.account-exists-with-different-credential":
    "Bu e-posta adresiyle zaten bir hesap var. Lütfen doğru yöntemle giriş yap.",
  "auth.error.google.invalid-credential":
    "Giriş bilgisi geçersiz veya süresi dolmuş. Lütfen tekrar dene.",
  "auth.error.google.user-disabled":
    "Hesabın devre dışı bırakıldı. Yardım için lütfen destekle iletişime geç.",
  "auth.error.google.user-not-found":
    "Bu e-posta adresiyle kayıtlı bir hesap bulunamadı. Lütfen tekrar dene veya yeni bir hesap oluştur.",
  "auth.error.google.wrong-password":
    "Girilen şifre yanlış. Lütfen tekrar dene.",

  "auth.error.signIn.invalid-email":
    "Girdiğin e-posta adresi geçersiz. Lütfen kontrol edip tekrar dene.",
  "auth.error.signIn.user-disabled":
    "Hesabın devre dışı bırakıldı. Yardım için lütfen destekle iletişime geç.",
  "auth.error.signIn.user-not-found":
    "Bu e-posta adresiyle kayıtlı bir hesap bulunamadı. Lütfen tekrar dene veya yeni bir hesap oluştur.",
  "auth.error.signIn.wrong-password":
    "Girdiğin şifre yanlış. Lütfen tekrar dene.",
  "auth.error.signIn.too-many-requests":
    "Çok fazla başarısız giriş denemesi. Lütfen daha sonra tekrar dene.",

  "auth.error.signUp.email-already-in-use":
    "Bu e-posta adresi başka bir hesap tarafından kullanılıyor. Lütfen farklı bir e-posta kullan.",
  "auth.error.signUp.invalid-email":
    "Girdiğin e-posta adresi geçersiz. Lütfen kontrol edip tekrar dene.",
  "auth.error.signUp.operation-not-allowed":
    "Şu anda yeni hesap oluşturulamıyor. Lütfen daha sonra tekrar dene.",
  "auth.error.signUp.weak-password":
    "Şifre en az 6 karakter olmalı. Lütfen daha güçlü bir şifre dene.",

  "auth.error.forgot.invalid-email": "Lütfen geçerli bir e-posta adresi gir.",
  "auth.error.forgot.user-not-found":
    "Bu e-postayla kayıtlı bir hesap bulunamadı.",
  "auth.error.forgot.missing-android-pkg-name": "Android paket adı gerekli.",
  "auth.error.forgot.missing-continue-uri": "Bir devam URL'si gerekli.",
  "auth.error.forgot.missing-ios-bundle-id": "iOS Bundle ID gerekli.",
  "auth.error.forgot.unauthorized-continue-uri":
    "Belirtilen devam URL'sine izin verilmiyor.",
  "auth.error.forgot.operation-not-allowed":
    "Bu proje için şifre sıfırlama etkin değil.",

  "auth.error.reset.invalid-action-code":
    "İşlem kodu geçersiz. Lütfen bağlantıyı kontrol edip tekrar dene.",
  "auth.error.reset.expired-action-code":
    "İşlem kodunun süresi doldu. Lütfen yeni bir şifre sıfırlama e-postası iste.",
  "auth.error.reset.user-disabled":
    "Bu kullanıcı hesabı devre dışı bırakıldı. Lütfen destekle iletişime geç.",
  "auth.error.reset.user-not-found":
    "Bu e-postayla kayıtlı bir hesap bulunamadı.",
  "auth.error.reset.weak-password": "Şifre en az 6 karakter olmalı.",
  "auth.error.reset.operation-not-allowed":
    "Bu proje için şifre sıfırlama etkin değil.",
  "auth.seo.loginTitle": "Giriş Yap - Jammable",
  "auth.seo.loginDescription": "Jammable hesabına giriş yap.",
  "auth.seo.signupTitle": "Kaydol | Jammable",
};

export default auth;
